import { createSelector } from 'reselect';
import objectToArray from '../../../../common/utils/object-to-array';

const topicsStateSelector = ({ entities: { topics } = {} }) => topics;

export const getTopics = createSelector([topicsStateSelector], topics => {
  return objectToArray(topics || {});
});



// WEBPACK FOOTER //
// ./src/App/account/selectors/customers/topics.js